<template>
  <span
    class="icon-wrapper"
    aria-hidden="true"
    :style="{
      width: size,
      height: size,
    }"
  >
    <component :is="icon" :fill="color" preserveAspectRatio="xMinYMid meet" />
  </span>
</template>

<script lang="ts">
  import styles from '@/assets/styles/exports.module.scss';
  import { defineAsyncComponent, defineComponent } from 'vue';

  export default defineComponent({
    props: {
      type: { type: String, required: true },
      color: { type: String, required: false, default: styles.colorGray },
      size: { type: String, required: false, default: '24px' },
    },
    computed: {
      icon() {
        return defineAsyncComponent(() => import(`../assets/images/icons/icon-${this.type}.svg`));
      },
    },
  });
</script>

<style lang="scss" scoped>
  .icon-wrapper {
    position: relative;
    display: inline-block;
    height: 0;
    vertical-align: -16%; // TODO: Hacky?
    svg {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>
